import { createAction,props } from '@ngrx/store';

export const setReferrals = createAction('[Referrals] setReferrals', props<{ reward:number, code:string }>());